import React from 'react';
import PropTypes from 'prop-types';

import { DemoPage } from '../../partials';

// Import code snippets as text.
const html = require('!raw-loader!flexbox-patterns/src/examples/post.html');
const css = require('!raw-loader!flexbox-patterns/src/styles/post.css');

export const PostDemo = ({ name }) => (
  <DemoPage title={name} html={html} css={css}>
    <p>
      If you&rsquo;re building a social media platform, you&rsquo;ll want to
      take a look at this pattern, which is an implementation of the generic{' '}
      {
        <a
          href="http://www.stubbornella.org/content/2010/06/25/the-media-object-saves-hundreds-of-lines-of-code/"
          target="_blank"
          rel="noopener noreferrer"
        >
          media object pattern
        </a>
      }
      . As Philip Walton demonstrates in{' '}
      {
        <a
          href="https://philipwalton.github.io/solved-by-flexbox/demos/media-object/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Solved by Flexbox
        </a>
      }
      , this pattern is incredibly versatile.
    </p>

    <p>
      A Post consists of a person&rsquo;s portrait and name placed to the left
      of a body of text. We want the portrait to stay a fixed width and height
      while the body expands horizontally to fill the remaining space in its
      container, regardless of how much text it contains.
    </p>

    <p>
      We&rsquo;ll use the same properties we used in the Card Group example, but
      in slightly different ways. For the portrait, we&rsquo;ll set{' '}
      <code>flex: 0 1 auto</code>. As I explained in the last example, this is
      short-hand for setting the <code>flex-grow</code>,<code>flex-shrink</code>
      , and <code>flex-basis</code> properties:
    </p>

    <ul>
      <li>
        <code>flex-grow: 0</code> will prevent this element from expanding to
        fill its container.
      </li>

      <li>
        <code>flex-shrink: 1</code> will cause this element to shrink as its
        container shrinks.
      </li>

      <li>
        <code>flex-basis: auto</code> will prevent it from shrinking below the
        width determined by its content.
      </li>
    </ul>

    <p>
      For the body of text, we&rsquo;ll set <code>flex: 1 1 0%</code>:
    </p>

    <ul>
      <li>
        <code>flex-grow: 1</code> will allow the body of text to expand to fill
        its container.
      </li>

      <li>
        <code>flex-shrink: 1</code> will allow it to shrink as its container
        shrinks.
      </li>

      <li>
        <code>flex-basis: 0%</code> will cause its size to be solely determined
        by the size of the container, instead of by its content.
      </li>
    </ul>
  </DemoPage>
);

PostDemo.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/demos/PostDemo.js